module.exports = {"id":"189596","name":"Thomas Müller","rating":"85","photo":"./data/images/photos/1/189596.png","club":{"name":"FC Bayern","logo":"./data/images/clubs/FCBayern.png"},"positions":["ATT","AD","MOC","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ThomasMuller0.json
// module id = 4113
// module chunks = 0